export const NativePlatformServiceModule = angular
    .module('app.services.access.nativePlatform', [])
    .service('nativePlatformService', ($window) => {
        const isIOS = getIsIOS($window);
        const isAndroid = getIsAndroid($window);
        const isMobileUserAgent = getIsMobileUserAgent($window);
        const service = {
            isIOS,
            isAndroid,
            isNative: (isIOS || isAndroid),
            isMobileUserAgent,
            getKit,
            getIsIOS,
            getIsAndroid,
            supports,
            logout
        };

        function getKit(win) {
            if (getIsIOS(win)) return win.webkit;
            if (getIsAndroid(win)) return win.androidkit;
            return undefined;
        }

        function getIsIOS(win) {
            return angular.isDefined(win.webkit) &&
                   angular.isDefined(win.webkit.messageHandlers) &&
                   (
                       angular.isDefined(win.webkit.messageHandlers.AnalyticsEventHandler) ||
                       angular.isDefined(win.webkit.messageHandlers.StatusBarUpdateHandler) ||
                       angular.isDefined(win.webkit.messageHandlers.LogoutHandler)
                   );
        }

        function getIsAndroid(win) {
            return angular.isDefined(win.androidkit);
        }

        function supports(win, handler) {
            const kit = getKit(win);

            if (getIsIOS(win)) {
                const messageHandler = kit.messageHandlers[handler];
                return angular.isDefined(messageHandler) &&
                       angular.isDefined(messageHandler.postMessage);
            }
            if (getIsAndroid(win)) {
                return angular.isDefined(kit[handler]);
            }
        }

        function logout(win) {
            const kit = getKit(win);

            if (getIsIOS(win) && supports(win, 'LogoutHandler')) {
                kit.messageHandlers.LogoutHandler.postMessage({});
            }
            if (getIsAndroid(win) && supports(win, 'handleLogout')) {
                kit.handleLogout();
            }
        }

        function getIsMobileUserAgent(win) {
            if (angular.isDefined(win) && angular.isDefined(win.navigator) &&
                angular.isDefined(win.navigator.userAgent)) {
                const userAgent = win.navigator.userAgent;
                // eslint-disable-next-line max-len
                return /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(userAgent);
            }
            return false;
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/access/nativePlatform/nativePlatform.service.js